import React from 'react';

const BrandHeader = () => {
  return (
    <div className="text-center mb-8">
      <h1 className="text-2xl font-semibold text-foreground mb-2" style={{ fontFamily: "'Crimson Text', serif" }}>
        Welcome Back
      </h1>
      <p className="text-muted-foreground">
        Sign in to continue your Shakespeare learning journey
      </p>
    </div>
  );
};

export default BrandHeader;